import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useLogout } from 'hooks/useAuthentication';

export const LogoutButton = () => {
  const navigate = useNavigate();
  const logout = useLogout();
  return (
    <Button
      type="button"
      variant="falcon-default"
      size="sm"
      className="ms-2"
      onClick={async () => {
        await logout.mutateAsync();
        navigate('/authentication/card/logout');
      }}
    >
      Logout
    </Button>
  );
};
